import { STATUS_BADGE } from "@/lib/constants";

export function StatusBadge({ status }) {
  const cls = STATUS_BADGE[status] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span data-testid={`status-badge-${status.replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap ${cls}`}>
      {status}
    </span>
  );
}
